<template>
  <section class="competition-slider section-gradient-wrapper" data-name="competition-slider-section">
    <div>
      <div class="competition-slider__header">
        <!-- <img v-if="image || titleIcon" class="categories-img" :src="image || titleIcon" /> -->

        <span class="competition-slider__title section__title">
          <icon name="competition" />
          {{ $t('titles.tournaments') }}
        </span>

        <div class="competition-slider__navigation">
          <router-link :to="{ name: 'Competitions', params: { type: 'all' } }" class="section__link" data-name="competition-slider-all-link">
            {{ $t('all') }}
          </router-link>
          <ol-slider-button
            :disabled-left="progress <= 0"
            :disabled-right="progress >= 1 || countSlides <= 1"
            data-name="competition-slider-nav"
            @click-left="prevSlide"
            @click-right="nextSlide"
          />
        </div>
      </div>
    </div>

    <div class="competition-slider__content">
      <swiper
        :key="isDesktop"
        class="groups"
        v-bind="swiperOptionComputed"
        data-name="competition-slider"
        @progress="onProgress"
        @swiper="onSwiper"
        @init="swiperReady = true"
      >
        <template v-if="nowCompetitions.length">
          <swiper-slide
            v-for="(competition, i) in nowCompetitions"
            :key="`${competition.name}-${i}`"
            class="swiper-slide"
          >
            <competition-item :key="competition" :item="competition" static-width @reload="refetch" />
          </swiper-slide>
        </template>
        <template v-else>
          <swiper-slide v-for="item of 8" :key="item" class="swiper-slide">
            <competition-item-skeleton static-width />
          </swiper-slide>
        </template>
      </swiper>
    </div>
  </section>
</template>

<script setup>
import CompetitionItem from 'src/components/competitions/CompetitionItem.vue'
import CompetitionItemSkeleton from 'src/components/competitions/CompetitionItemSkeleton.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'

import getCompetitionsNew from 'src/apollo/queries/getCompetitions.gql'
import { OlSliderButton } from '@gamesite/olimp-core'
import { useQuery } from '@vue/apollo-composable'
import { computed, inject, ref } from 'vue'
import { Grid, FreeMode } from 'swiper/modules'

//TODO store... было - const isLocalUser = computed(() => store.getters.isLocalUser) // в сторе нет этого геттера
const isLocalUser = computed(() => false)

const { result, refetch } = useQuery(getCompetitionsNew, { now: true }, { enabled: !isLocalUser.value })

const nowCompetitions = computed(() => result.value?.competitions.edges.map((i) => i.node) || [])

const swiperOptionComputed = computed(() => {
  const grid = {
    fill: 'column',
    rows: 1,
  }

  const swiperOption = {
    spaceBetween: 10,
    slideToClickedSlide: false,
    slidesPerGroup: 1,
    modules: [Grid],
    grid,
    loop: true,
    freeMode: true,
  }

  const breakpoints = () => {
    return {
      320: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        modules: [Grid],
        grid,
        centeredSlides: false,
        spaceBetween: 0,
      },
      576: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        modules: [Grid],
        grid,
        centeredSlides: false,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        modules: [Grid],
        grid,
        centeredSlides: false,
        spaceBetween: 8,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        modules: [Grid, FreeMode],
        grid,
        cssMode: false,
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        modules: [Grid, FreeMode],
        cssMode: false,
        grid,
      },
    }
  }

  return {
    ...swiperOption,
    // slidesPerView: 1,
    breakpoints: breakpoints(),
  }
})

const swiperInstance = ref(null)

const countSlides = computed(() => {
  if (!swiperInstance.value?.params) {
    return null
  }
  const { slides, params } = swiperInstance.value
  return (slides?.length ?? 0) / params.slidesPerView
})

const mediaQueries = inject('mediaQueries')
const isDesktop = computed(() => {
  return mediaQueries.desktop
})

const progress = ref(0)

function onProgress(swiper, progressValue) {
  progress.value = progressValue
}

function onSwiper(swiper) {
  swiperInstance.value = swiper
}

function nextSlide() {
  swiperInstance.value.slideNext()
}

function prevSlide() {
  swiperInstance.value.slidePrev()
}
</script>

<style lang="scss">
.competition-slider {
  .swiper-slide {
    width: 200px;
  }

  &__header {
    display: flex;
    align-items: center;

    @media screen and (max-width: 768px) {
      padding: 0 12px;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 8px;

    > i {
      width: 24px;
      // height: 24px;

      @media screen and (max-width: 1024px) {
        width: 16px;
        // height: 16px;
      }
    }
  }

  &__navigation {
    display: flex;
    gap: 8px;
    align-items: center;

    a {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.7);
    }
  }

  &__content {
    @media screen and (max-width: 768px) {
      .swiper {
        // padding: 0 12px;
      }
      .swiper-wrapper {
        > * {
          padding-left: 10px;
          width: 210px;
          &:first-child {
            padding-left: 12px;
            width: 212px;
          }

          &:last-child {
            padding-right: 12px;
            width: 222px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0;
  }
}
</style>
